(() => {
  'use strict';
  function validInstallments(value) {
    return Boolean(value && value.split(',').map(item => item.trim()).every(item => ['3','6','9','12'].includes(item)));
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { validInstallments };
  if (typeof document === 'undefined') return;
  const host = document.querySelector('script[data-neko-payment-widget-src]');
  if (!host) return;
  const placements = '[data-mercado-pago-widget], .mercado-pago-widget, .mp-widget, .widget-mercado-pago, #widget_mercado_pago, #mercado-pago-widget, #mp-widget';
  let frame;
  const load = () => {
    if (document.querySelector('script[data-name="shopifyMercadoPagoWidget"]')) { observer.disconnect(); return; }
    const configured = [...document.querySelectorAll(placements)].some(element => validInstallments(element.getAttribute('cuotas')));
    if (!configured) return;
    const script = document.createElement('script');
    script.src = host.dataset.nekoPaymentWidgetSrc;
    script.dataset.name = 'shopifyMercadoPagoWidget';
    script.defer = true;
    document.head.append(script);
    observer.disconnect();
  };
  const observer = new MutationObserver(() => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(load);
  });
  observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['cuotas'] });
  load();
})();
